import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { deleteNotes } from 'src/helper/backendHelper'
import { toast } from 'react-toastify'
import GenericConfirmModal from './GenericConfirmModal'

export default function DeleteNote({ visible, onChange, chart_id, handleClose }) {
  const [isClicked, setIsClicked] = useState(false)

  const handleClick = () => {
    if (chart_id) {
      deleteNotes(chart_id).then((res) => {
        if (res?.status === 'success') {
          toast.success('Visit notes deleted successfully')
          onChange()
        } else {
          toast.error('Note deletion failed')
          handleClose()
        }
        setIsClicked(false)
      })
    } else {
      // may be a lag issue and chart has
      // already been deleted
      setIsClicked(false)
    }
  }

  return (
    visible && (
      <GenericConfirmModal
        content={'Progress note draft will be deleted'}
        onClose={handleClose}
        onConfirm={() => {
          if (!isClicked) {
            setIsClicked(true)
            handleClick()
          }
        }}
      />
    )
  )
}

DeleteNote.propTypes = {
  visible: PropTypes.bool,
  chart_id: PropTypes.string,
  onChange: PropTypes.func,
  handleClose: PropTypes.func,
}
